<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-14 20:04:06
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-29 17:28:01
-->
<template>
	<div class="flex tips" :class="type" v-if="showTip">
		<i class="el-icon-info flex-row-align-center icon-info" :class="[`yx-color-${type}`, iconSize]"></i>
		<p class="ml-10 pre yx-color-text-primary pre-wrap" :class="[textSize]" v-if="!$slots['content']">
			<template v-if="$slots.default">{{ $slots.default[0].text && $slots.default[0].text.trim() }}</template>
			<slot v-else>{{ content.trim && content.trim() }}</slot>
		</p>
		<slot name="content" v-else></slot>
		<i class="el-icon-close pos-abso" v-if="showCloseIcon" style="right: 53px;" @click="closeTip"></i>
	</div>
</template>
<script>
export default {
	props: {
		content: {
			type: String,
			default: '',
		},
		type: {
			type: String,
			default: 'primary',
		},
		showIcon: {
			type: Boolean,
			default: true,
		},
		size: {
			type: String,
			default: 'normal',
			validator: val => ['normal', 'small'].includes(val),
		},
		showCloseIcon:{
			type: Boolean,
			default: false,
		},
	},
	computed: {
		iconSize({ size }) {
			return `fz-${size === 'small' ? 14 : 18}`;
		},
		textSize({ size }) {
			return `font-h${size === 'small' ? 6 : 4}-regular`;
		},
	},
	data(){
		return{
			showTip:true
		}
	},
	methods:{
		closeTip(){
			this.showTip = false
		}
	}
};
</script>
<style lang="less" scoped>
.tips {
	padding: 12px 16px;
	border-radius: 8px;
	color: @color-text-primary;
	&.primary {
		border: 1px solid @color-b2;
		background-color: @color-b1;
	}
	&.warning {
		background-color: @color-o1;
		border: 1px solid @color-o2;
	}
}
.icon-info{
	position: relative;
	top: 3px;
}
</style>
